export default "__VITE_ASSET__522218c9__"